






import { Component, Mixins } from 'vue-property-decorator';
import SmsPointMixin from './mixins/smsPointMixin';

@Component
export default class MessageSendCount extends Mixins(SmsPointMixin) {
  private get smsCount() {
    const point = Number(this.totalPoint);
    return Math.max(0, Math.floor(point)).toLocaleString();
  }

  private get alimtalkCount() {
    const point = Number(this.totalPoint);
    return Math.max(0, Math.floor(point / 0.6)).toLocaleString();
  }
}
